/* Article page enhancements: auto table of contents + copy-link share.
   No dependencies. Runs once on DOMContentLoaded. */
(function () {
  function slugify(text, used) {
    var base = (text || '')
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    if (!base) base = 'section';
    var slug = base;
    var i = 2;
    while (used[slug]) {
      slug = base + '-' + i;
      i++;
    }
    used[slug] = true;
    return slug;
  }

  function buildTOC() {
    var toc = document.querySelector('[data-toc]');
    var list = document.querySelector('[data-toc-list]');
    var content = document.querySelector('.article-template__content');
    if (!toc || !list || !content) return;

    var headings = content.querySelectorAll('h2');
    if (headings.length < 3) {
      toc.remove();
      return;
    }

    var used = {};
    var items = [];
    headings.forEach(function (h) {
      if (!h.id) h.id = slugify(h.textContent, used);
      else used[h.id] = true;

      var li = document.createElement('li');
      li.className = 'article-toc__item';
      var a = document.createElement('a');
      a.className = 'article-toc__link';
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(h.id);
        if (!target) return;
        var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
        history.replaceState(null, '', '#' + h.id);
      });
      li.appendChild(a);
      list.appendChild(li);
      items.push({ id: h.id, link: a, heading: h });
    });

    toc.hidden = false;

    // Highlight the section currently in view.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            items.forEach(function (it) {
              it.link.classList.toggle('is-active', it.id === entry.target.id);
            });
          });
        },
        { rootMargin: '-80px 0px -70% 0px', threshold: 0 }
      );
      items.forEach(function (it) {
        observer.observe(it.heading);
      });
    }

    // Mobile accordion toggle.
    var toggle = toc.querySelector('[data-toc-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        toc.classList.toggle('is-open');
        var expanded = toc.classList.contains('is-open');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }
  }

  function initCopyShare() {
    document.querySelectorAll('[data-share-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-share-url') || window.location.href;
        var label = btn.querySelector('[data-share-copy-label]');
        var done = function () {
          if (!label) return;
          var original = label.textContent;
          label.textContent = 'Copied!';
          btn.classList.add('is-copied');
          setTimeout(function () {
            label.textContent = original;
            btn.classList.remove('is-copied');
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(done);
        } else {
          var tmp = document.createElement('input');
          tmp.value = url;
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(tmp);
          done();
        }
      });
    });
  }

  function init() {
    buildTOC();
    initCopyShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
